export function lower(s) {
    return String(s || "").toLowerCase().trim();
  }
  
  export function toTokens(q) {
    return lower(q).split(/[^a-z0-9]+/g).filter(Boolean);
  }
  
  export function extractYear(text) {
    const m = String(text || "").match(/(\d{3,4})/);
    return m ? Number(m[1]) : null;
  }
  